/**
 * The extension's stores, kept apart from whether it is here
 * (`extensionPresence.ts`): the extension's own suite loads that module
 * outside Vite, and this one reads Vite's build settings.
 */

/**
 * Where to install the extension: one source for every Add to Chrome and
 * Add to Firefox. Chrome's is the published listing. Firefox's is still
 * the store's search until its listing is live; replace it then.
 */
export const EXTENSION_STORES = {
    chrome: "https://chromewebstore.google.com/detail/job-envoy/lnpeekjahbgkfooenmnlmnobckbjloml",
    firefox: "https://addons.mozilla.org/firefox/search/?q=Job%20Envoy",
} as const;

export type ExtensionStore = keyof typeof EXTENSION_STORES;

export const EXTENSION_STORE_LABELS: Record<ExtensionStore, string> = {
    chrome: "Add to Chrome",
    firefox: "Add to Firefox",
};

/**
 * The stores to offer, in order. Firefox only once its listing is live,
 * `VITE_FIREFOX_LISTED=true` at build; until then every Add to Firefox is
 * left out. Read on each call, so Vite writes the value into the build.
 */
export function extensionStores(): ExtensionStore[] {
    return import.meta.env.VITE_FIREFOX_LISTED === "true" ? ["chrome", "firefox"] : ["chrome"];
}
